module.exports = __webpack_public_path__ + "static/hero3-13bb847a08cc89755a9683a2b090ab18.jpg";